// extracted by mini-css-extract-plugin
module.exports = {"default":"Section_default__189k2","section_block":"Section_section_block__zX1Ql","wrapper":"Section_wrapper__12IS1","smallSection":"Section_smallSection__3xjdC"};